export const MASTER_APL_NAME = 'Master APL';
export const COMPANY_PRODUCT_MANAGER_ROLE = 'Company Products Manager';
export const COMPANY_ADMINISTRATOR = 'Company Administrator';
export const VAULT_TIER_2_ADMIN = 'Vault Tier 2 Admin';
